module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_100.59cbb455.gif";